import {
  meetingSupportLists,
  type MeetingSupportInput,
} from "@/lib/meeting-support";

// TES-1294 — "Mötesstöd", visually apart from the journal card: a dashed,
// muted box, so nothing in it reads as a heading of the note. Its lines are
// never copied into the note (the note is assembled from the journal boxes
// alone, MeetingWorkspace.openWebdocStep).
export function MeetingSupportPanel(props: MeetingSupportInput) {
  const { inform, after } = meetingSupportLists(props);
  return (
    <aside
      aria-labelledby="meeting-support-heading"
      className="rounded-lg border border-dashed border-surfaceMuted bg-background p-md"
      data-testid="meeting-support"
    >
      <h2
        id="meeting-support-heading"
        className="text-sm font-semibold text-textPrimary"
      >
        Mötesstöd
      </h2>
      <p className="text-xs text-textSecondary">
        Ingår inte i journalanteckningen.
      </p>
      <Group title="Information att förmedla" lines={inform} />
      <Group title="Åtgärder efter mötet" lines={after} />
    </aside>
  );
}

function Group({ title, lines }: { title: string; lines: string[] }) {
  return (
    <section className="mt-sm">
      <h3 className="text-xs font-semibold text-textSecondary">{title}</h3>
      <ul className="mt-[2px] list-disc pl-lg text-sm text-textPrimary">
        {lines.map((l) => (
          <li key={l}>{l}</li>
        ))}
      </ul>
    </section>
  );
}
